var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("stock-compute-edit-title")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-stock-location-select", {
                    attrs: { label: _vm.$ct("stock-location") },
                    model: {
                      value: _vm.toEditConf.StockLocation,
                      callback: function ($$v) {
                        _vm.$set(_vm.toEditConf, "StockLocation", $$v)
                      },
                      expression: "toEditConf.StockLocation",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { fancy: "", label: _vm.$ct("stock-qty") },
                    model: {
                      value: _vm.toEditConf.Qty,
                      callback: function ($$v) {
                        _vm.$set(_vm.toEditConf, "Qty", $$v)
                      },
                      expression: "toEditConf.Qty",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      items: _vm.qtyComesFromFieldItems,
                      fancy: "",
                      label: _vm.$ct("stock-qty-comes-from-field"),
                    },
                    model: {
                      value: _vm.toEditConf.QtyComesFromField,
                      callback: function ($$v) {
                        _vm.$set(_vm.toEditConf, "QtyComesFromField", $$v)
                      },
                      expression: "toEditConf.QtyComesFromField",
                    },
                  }),
                ],
                1
              ),
              _c("app-conditions-edit", {
                attrs: {
                  conditions: _vm.toEditConf.Filter,
                  fields: _vm.conditionProps,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }